import { useQuery } from '@tanstack/react-query';
import { useApi } from '../../providers/ApiProvider';

export function useUsers({
  enabled = true,
  page = 1,
  search_query = '',
  status = '',
}: {
  enabled?: boolean;
  page?: number;
  search_query?: string;
  status?: string;
}) {
  const api = useApi();

  return useQuery({
    queryKey: ['users', page, search_query, status], 
    queryFn: async () => {
      const res = await api.GET({
        endpoint: 'users',
        params: { page, search_query, status },
      });
      return res;
    },
    enabled,
  });
}
